var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFpsManual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19.778,
    viewBox: "0 0 22 19.778",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36418",
    "data-name": "Group 36418",
    transform: "translate(-2 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39801",
    "data-name": "Path 39801",
    d: "M19.667,4H6.333A3.333,3.333,0,0,0,3,7.333V18.444a3.333,3.333,0,0,0,3.333,3.333H19.667A3.333,3.333,0,0,0,23,18.444V7.333A3.333,3.333,0,0,0,19.667,4Z",
    transform: "translate(0 -4)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39802",
    "data-name": "Path 39802",
    d: "M9.222,12.444A2.222,2.222,0,1,0,7,10.222,2.222,2.222,0,0,0,9.222,12.444Z",
    transform: "translate(0.444 -3.556)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39803",
    "data-name": "Path 39803",
    d: "M15,8h2.222",
    transform: "translate(1.333 -3.556)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39804",
    "data-name": "Path 39804",
    d: "M15,12h2.222",
    transform: "translate(1.333 -3.111)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39805",
    "data-name": "Path 39805",
    d: "M7,16H18.111",
    transform: "translate(0.444 -2.667)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFpsManual);
export default __webpack_public_path__ + "static/media/fps-manual.da7eb1c33b4776410499ac10dde09be9.svg";
export { ForwardRef as ReactComponent };